export const getFeatures = (t) => [
  {
    title: t('reservations:amenityMarketplaceModal.features.newRevenue.title'),
    description: t('reservations:amenityMarketplaceModal.features.newRevenue.description'),
  },
  {
    title: t('reservations:amenityMarketplaceModal.features.fullControl.title'),
    description: t('reservations:amenityMarketplaceModal.features.fullControl.description'),
  },
  {
    title: t('reservations:amenityMarketplaceModal.features.builtInOps.title'),
    description: t('reservations:amenityMarketplaceModal.features.builtInOps.description'),
  },
  {
    title: t('reservations:amenityMarketplaceModal.features.calendarSync.title'),
    description: t('reservations:amenityMarketplaceModal.features.calendarSync.description'),
  },
]

export const VIDEO_URL =
  'https://d3b2rqyxkxi2am.cloudfront.net/videos/amenity-marketplace-marketing-video.mp4'
